import { Project, ProjectFromDiscoveryService, ProjectResource } from '../../models/project';
import { createStringIdAdapter } from './common/string-id-adapter';

export const projectResourceAdapter = createStringIdAdapter<ProjectResource>();

export const projectAdapter = createStringIdAdapter<Project>();

export const projectsFromDiscoveryServiceAdapter = createStringIdAdapter<ProjectFromDiscoveryService>();
